module.exports = __webpack_public_path__ + "static/media/cherry_compote.0209cfd5.png";